var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ui segment secondary form', _vm.customClass, { inverted: _vm.theme }]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }